/** Global Vue Mixins
 *  @function returnBasePath
 *    Returns a string formed by the combination of relative path and assets root
 *    @param {String} str - relative path to asset
 *
 *  @function checkAdvertisment
 *    Check if the loaded template contains an advertisment component and loads/unloads it
 *    @param {Object} obj - the advertisment block in the ajax call response
 *
 *  @function changeSkin
 *    Adds class to main app wrapper relative to the path in the wizard
 *    @param {String} answer - the current path in wizard
 *
 *  @function reloadQuestion
 *    Reload the same template with same data and forces update
 *    @param {Function} callback - callback to bind data in component
 *    @param {Object} res - the ajax call response
 *
 *  @function makeNextCall
 *    Sends answer choice to backend and loads next template
 *    @param {Int} questionId - unique ID of current question
 *    @param {Int} answerId - unique ID of chosen answer
 *    @param {Function} callback - callback to bind data in component
 *    @param {String=} value - optional value to send to backend
 *
 *  @function makeBackCall
 *    Sends current template info to backend and loads previous template
 *    @param {Int} questionId - unique ID of current question
 *    @param {Function} callback - callback to bind data in component
 *
 *  @function makeDismissCall
 *    Sends current template info to backend and loads underlying template
 *    @param {Int} questionId - unique ID of current question
 *    @param {Function} callback - callback to bind data in component
 *
 */

export default{
  methods: {
    returnBasePath(str){
      return WIZARD.assetsBasePath + str;
    },
    checkAdvertisment(obj){
      var vm = this;
      if (obj) {
        vm.$store.state.advertismentConfig = {};
        vm.$store.state.hasAdvertisment = false;
        setTimeout(function () {
          if (obj.image || obj.products) {
            vm.$store.state.advertismentConfig = obj;
            vm.$store.state.hasAdvertisment = true;
          }
          else {
            vm.$store.state.advertismentConfig = {};
            vm.$store.state.hasAdvertisment = false;
          }
        }, 100);
      }
      else {
        vm.$store.state.advertismentConfig = {};
        vm.$store.state.hasAdvertisment = false;
      }
    },
    changeSkin(answer) {
      var wrapper = document.getElementsByClassName('wizard-wrapper')[0];
      switch (answer.toLowerCase()) {
        case 'sistema di raffrescamento':
          wrapper.classList.add("raffrescamento");
          wrapper.classList.remove("riscaldamento");
          wrapper.classList.remove("combinato");
          break;
        case 'sistema di riscaldamento':
          wrapper.classList.remove("raffrescamento");
          wrapper.classList.add("riscaldamento");
          wrapper.classList.remove("combinato");
          break;
        case 'Sistema combinato caldo/freddo':
          wrapper.classList.remove("raffrescamento");
          wrapper.classList.remove("riscaldamento");
          wrapper.classList.add("combinato");
          break;
        default:
          wrapper.classList.remove("raffrescamento");
          wrapper.classList.remove("riscaldamento");
          wrapper.classList.remove("combinato");
          break;
      }
    },
    reloadQuestion(callback, res){
      var vm = this;
      if (res.result == 'success' && res.code == 200) {
        vm.$store.state.hasBannerHelp = res.response.bannerHelp;
        vm.checkAdvertisment(res.response.advertisment);
        vm.$store.state.templates.forEach(function (elem) {
          if (elem.name == res.response.template && callback) {
            if (vm.$store.state.tempConfigObj.template == res.response.template) {
              vm.$store.state.tempConfigObj = {};
              vm.$store.state.hasMainView = false;
              setTimeout(function () {
                vm.$store.state.hasMainView = true;
              }, 15)
            }
            vm.$store.state.tempConfigObj = res.response;
            vm.$store.state.hasBack = vm.$store.state.tempConfigObj.template != 'start_stnd_a';
            if (vm.$store.state.tempConfigObj.template == 'question_split' ||
              vm.$store.state.tempConfigObj.template == 'loop_rooms') {
              vm.$store.state.tempConfigObj.answers.pop();
            }
            $('html, body').animate({scrollTop: 0}, 0);
            callback();
          }
        });
      }
    },
    makeNextCall(questionId, answerId, callback, value){
      var data = {
        questionId: questionId,
        answerId: answerId
      };
      if (value !== undefined) {
        data.value = value;
      }
      var vm = this;
      //vm.$store.state.isApplicationLoading = true;
      $.ajax({
        type: 'GET',
        url: vm.$store.state.routes.nextURL,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: data,
        success: function (res) {
          //vm.$store.state.isApplicationLoading = false;
          if (res.result == 'success' && res.code == 200) {
            vm.$store.state.hasBannerHelp = res.response.bannerHelp;
            console.log(vm.$store.state);
            vm.checkAdvertisment(res.response.advertisment);
            vm.$store.state.templates.forEach(function (elem) {
              if (elem.name == res.response.template && callback) {
                vm.$store.state.tempConfigObj = {};
                vm.$store.state.hasMainView = false;
                setTimeout(function () {
                  vm.$store.state.hasMainView = true;
                }, 50);
                vm.$store.state.tempConfigObj = res.response;
                vm.$store.state.hasBack = vm.$store.state.tempConfigObj.template != 'start_stnd_a';
                if (vm.$store.state.tempConfigObj.template == 'question_split' ||
                  vm.$store.state.tempConfigObj.template == 'loop_rooms') {
                  vm.$store.state.tempConfigObj.answers.pop();
                }
                $('html, body').animate({scrollTop: 0}, 0);
                callback();
              }
            });
          }
        },
        error: function (err) {
          console.log('Error: ');
          //vm.$store.state.isApplicationLoading = false;
          console.log(err);
        }
      });
    },
    makeBackCall(questionId, callback){
      var vm = this;
      //vm.$store.state.isApplicationLoading = true;
      $.ajax({
        type: 'GET',
        url: vm.$store.state.routes.backURL,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: {
          questionId: questionId
        },
        success: function (res) {
          //vm.$store.state.isApplicationLoading = false;
          if (res.result == 'success' && res.code == 200) {
            vm.checkAdvertisment(res.response.advertisment);
            vm.$store.state.templates.forEach(function (elem) {
              if (elem.name == res.response.template && callback) {
                vm.$store.state.tempConfigObj = {};
                vm.$store.state.hasMainView = false;
                setTimeout(function () {
                  vm.$store.state.hasMainView = true;
                }, 15);
                vm.$store.state.tempConfigObj = res.response;
                vm.$store.state.hasBack = vm.$store.state.tempConfigObj.template != 'start_stnd_a';
                if (vm.$store.state.tempConfigObj.template == 'question_split' ||
                  vm.$store.state.tempConfigObj.template == 'loop_rooms') {
                  vm.$store.state.tempConfigObj.answers.pop();
                }
                if (vm.$store.state.tempConfigObj.template == 'start_stnd_a') {
                  vm.changeSkin('default');
                }
                if (vm.$store.state.tempConfigObj.template == 'product_cart') {
                  $.ajax({
                    method: "POST",
                    url: WIZARD.ajaxRoutes.cart.remove,
                    dataType: 'json',
                    data: {
                      SKU: vm.$store.state.productListing[vm.$store.state.productListing.length - 1]
                    }
                  });
                  vm.$store.state.productListing.pop();
                }
                $('html, body').animate({scrollTop: 0}, 0);
                callback();
              }
            });
          }
        },
        error: function (err) {
          //vm.$store.state.isApplicationLoading = false;
          console.log('Error: ');
          console.log(err);
        }
      });
    },
    makeDismissCall(questionId, callback){
      var vm = this;
      //vm.$store.state.isApplicationLoading = true;
      $.ajax({
        type: 'GET',
        url: vm.$store.state.routes.dismissURL,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: {
          questionId: questionId
        },
        success: function (res) {
          //vm.$store.state.isApplicationLoading = false;
          if (res.result == 'success' && res.code == 200) {
            if (res.response.advertisment) {
              if (res.response.advertisment.image || res.response.advertisment.products) {
                vm.$store.state.advertismentConfig = res.response.advertisment;
                vm.$store.state.hasAdvertisment = true;
              }
              else {
                vm.$store.state.advertismentConfig = {};
                vm.$store.state.hasAdvertisment = false;
              }
            }
            else {
              vm.$store.state.advertismentConfig = {};
              vm.$store.state.hasAdvertisment = false;
            }
            vm.$store.state.templates.forEach(function (elem) {
              if (elem.name == res.response.template && callback) {
                /*
                 if (vm.$store.state.tempConfigObj.template == res.response.template) {
                 vm.$store.state.tempConfigObj = {};
                 vm.$store.state.hasMainView = false;
                 setTimeout(function () {
                 vm.$store.state.hasMainView = true;
                 }, 15)
                 }
                 */
                vm.$store.state.tempConfigObj = {};
                vm.$store.state.hasMainView = false;
                setTimeout(function () {
                  vm.$store.state.hasMainView = true;
                }, 15);
                vm.$store.state.tempConfigObj = res.response;
                vm.$store.state.hasBack = vm.$store.state.tempConfigObj.template != 'start_stnd_a';
                if (vm.$store.state.tempConfigObj.template == 'question_split' ||
                  vm.$store.state.tempConfigObj.template == 'loop_rooms') {
                  vm.$store.state.tempConfigObj.answers.pop();
                }
                $('html, body').animate({scrollTop: 0}, 0);
                callback();
              }
            });
          }
        },
        error: function (err) {
          //vm.$store.state.isApplicationLoading = false;
          console.log('Error: ');
          console.log(err);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js